// ============ ZEN ERP TEMA MOTORU ============
// "Orijinal" tema hiç dokunulmadan kalır (App.css :root / html.dark varsayılanları).
// Diğer temalar CSS custom property override + [class*="..."] seçicileriyle UYGULANIR —
// App.js/quotes.jsx/purchaseLists.jsx içindeki mevcut hardcoded Tailwind sınıflarına
// (örn. bg-[#E5322A], border-[#22304A]) dokunmadan, onları CSS üzerinden "yeniden boyarız".

export const BUILTIN_THEMES = [
  {
    id: "orijinal", name: "Orijinal", category: "system", mode: "system",
    desc: "Mevcut ZEN ERP görünümü — değişmez.",
  },
  {
    id: "apple_light", name: "Liquid Glass — Açık", category: "apple", mode: "light", pairId: "apple_dark",
    desc: "Buzlu cam paneller, sıvı metal butonlar, yumuşak beyaz parlamalar, SF Pro tipografi.",
    colors: {
      primary: "#007AFF", primaryHover: "#0066D6", accent: "#5856D6",
      bgLight: "#F2F2F7", panelLight: "rgba(255,255,255,0.55)", panel2Light: "#FFFFFF",
      borderLight: "#D1D1D6", textLight: "#000000", mutedLight: "#8E8E93", rowAltLight: "#F9F9FB",
    },
    radius: "26px", font: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro Display', Inter, system-ui, sans-serif",
    buttonStyle: "pill", glass: true, animation: "none",
  },
  {
    id: "apple_dark", name: "Liquid Glass — Koyu", category: "apple", mode: "dark", pairId: "apple_light",
    desc: "Saf siyah zemin, buzlu koyu cam paneller, sıvı metal butonlar, SF Pro tipografi.",
    colors: {
      primary: "#0A84FF", primaryHover: "#409CFF", accent: "#5E5CE6",
      bgDark: "#000000", panelDark: "rgba(28,28,30,0.55)", panel2Dark: "#1C1C1E",
      borderDark: "#38383A", textDark: "#FFFFFF", mutedDark: "#98989D", rowAltDark: "#131315",
    },
    radius: "26px", font: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro Display', Inter, system-ui, sans-serif",
    buttonStyle: "pill", glass: true, animation: "none",
  },
];

// Hardcoded Tailwind hex sınıflarını semantik role eşler — override CSS üretiminde kullanılır.
export const HEX_ROLE_MAP = {
  "E5322A": "primary",
  "22304A": "borderDark",
  "131B2E": "panelDark",
  "0C1220": "bgDark",
  "0B1220": "bgDark",
  "31405D": "borderDark",
  "2B3A58": "panel2Dark",
  "2B3B5C": "borderDark",
  "0F1626": "panel2Dark",
  "10182A": "panel2Dark",
  "1A2340": "panel2Dark",
  "1E2D44": "panel2Dark",
  "16213A": "panel2Dark",
  "1A2438": "borderDark",
};
const HEX_PROPS = [
  { prefix: "bg", css: "background-color" },
  { prefix: "text", css: "color" },
  { prefix: "border", css: "border-color" },
  { prefix: "ring", css: "box-shadow" },
];

const BUTTON_STYLE_CSS = {
  solid: ``,
  outline: `
    .zen-btn-primary { background: transparent !important; color: var(--zen-red) !important; border: 1.5px solid var(--zen-red) !important; }
    .zen-btn-primary:hover { background: color-mix(in srgb, var(--zen-red) 12%, transparent) !important; }`,
  pill: `
    .zen-btn-primary, .zen-btn-ghost, .zen-btn-secondary { border-radius: 999px !important; }`,
  glass: `
    .zen-btn-primary { border-radius: var(--zen-radius) !important; backdrop-filter: blur(6px); box-shadow: 0 6px 18px -6px color-mix(in srgb, var(--zen-red) 55%, transparent); }
    .zen-btn-ghost, .zen-btn-secondary { border-radius: var(--zen-radius) !important; }`,
  clay: `
    .zen-btn-primary { border-radius: var(--zen-radius) !important; box-shadow: 5px 5px 10px rgba(0,0,0,0.12), -5px -5px 10px rgba(255,255,255,0.7), inset 0 0 0 rgba(0,0,0,0); border: none !important; }
    .zen-btn-ghost, .zen-btn-secondary { border-radius: var(--zen-radius) !important; box-shadow: 3px 3px 7px rgba(0,0,0,0.10), -3px -3px 7px rgba(255,255,255,0.6); border: none !important; }
    .zen-panel { box-shadow: 6px 6px 14px rgba(0,0,0,0.10), -6px -6px 14px rgba(255,255,255,0.65); border: none !important; }`,
  neon: `
    .zen-btn-primary { border-radius: var(--zen-radius) !important; box-shadow: 0 0 8px var(--zen-red), 0 0 22px color-mix(in srgb, var(--zen-red) 55%, transparent); text-shadow: 0 0 6px rgba(0,0,0,0.4); }
    .zen-btn-ghost, .zen-btn-secondary { border-radius: var(--zen-radius) !important; }
    .zen-panel { box-shadow: 0 0 0 1px color-mix(in srgb, var(--zen-red) 25%, transparent), 0 0 18px -8px var(--zen-red); }`,
  holo: `
    .zen-btn-primary { border-radius: var(--zen-radius) !important; backdrop-filter: blur(8px); box-shadow: 0 0 20px -4px var(--zen-red); }
    .zen-btn-ghost, .zen-btn-secondary { border-radius: var(--zen-radius) !important; }
    .zen-panel { backdrop-filter: blur(14px) saturate(1.4); }`,
};

/**
 * Apple (Liquid Glass) temaları için özel CSS: sadece renk değişkenleri değil, TÜM bileşen
 * stilini (glassmorphism, derinlik, sıvı-metal butonlar, sadeleştirilmiş tipografi, ince ikonlar)
 * baştan aşağı yeniden kurar. `[data-theme="apple_light|apple_dark"]` scope'unda çalışır.
 */
function buildAppleGlassCSS(theme, sel) {
  const isDark = theme.mode === "dark";
  const glow = isDark ? "rgba(255,255,255,0.10)" : "rgba(255,255,255,0.75)";
  const glowSoft = isDark ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.45)";
  const glassBg = isDark ? "rgba(24,24,27,0.42)" : "rgba(255,255,255,0.42)";
  const glassBgStrong = isDark ? "rgba(18,18,20,0.55)" : "rgba(255,255,255,0.55)";
  const shadowAmbient = isDark ? "rgba(0,0,0,0.55)" : "rgba(31,38,60,0.12)";
  const bgWash = isDark
    ? "radial-gradient(at 10% 10%, rgba(60,120,230,0.55) 0, transparent 60%), radial-gradient(at 90% 5%, rgba(160,70,230,0.45) 0, transparent 60%), radial-gradient(at 15% 90%, rgba(10,132,255,0.40) 0, transparent 60%), radial-gradient(at 90% 95%, rgba(220,80,160,0.35) 0, transparent 60%), radial-gradient(at 50% 50%, rgba(80,90,180,0.25) 0, transparent 70%), #050508"
    : "radial-gradient(at 10% 10%, rgba(130,185,255,0.55) 0, transparent 60%), radial-gradient(at 90% 5%, rgba(170,210,255,0.45) 0, transparent 60%), radial-gradient(at 15% 90%, rgba(100,165,255,0.50) 0, transparent 60%), radial-gradient(at 90% 95%, rgba(160,215,255,0.40) 0, transparent 60%), radial-gradient(at 50% 50%, rgba(140,185,255,0.20) 0, transparent 70%), #EEF5FF";

  return `
/* ---- Zemin: buzlu cam efektinin görünür olması için degradeli arka plan ---- */
${sel}, ${sel} body, ${sel} #root, ${sel} main {
  background: ${bgWash} !important;
  background-attachment: fixed !important;
}

/* ---- Glassmorphism: tüm panel/kart/modal yüzeyleri şeffaf + buzlu cam ---- */
${sel} .zen-panel {
  background: ${glassBg} !important;
  backdrop-filter: blur(28px) saturate(1.7);
  -webkit-backdrop-filter: blur(28px) saturate(1.7);
  border: 1px solid ${glow} !important;
  border-radius: var(--zen-radius) !important;
  box-shadow: 0 10px 34px -6px ${shadowAmbient}, inset 0 1px 0 ${glowSoft};
}
${sel} header, ${sel} [data-testid="zen-sidebar"] {
  background: ${glassBgStrong} !important;
  backdrop-filter: blur(30px) saturate(1.8);
  -webkit-backdrop-filter: blur(30px) saturate(1.8);
  border-color: ${glow} !important;
}
${sel} .fixed.inset-0.bg-black\\/60 {
  backdrop-filter: blur(10px) saturate(1.3) !important;
}
/* ---- .zen-panel dışında kalan (bg-white / bg-slate-50/100 / border-slate-*) düz Tailwind
       yüzeyler de aynı buzlu cam muamelesini görsün — App.js'teki yüzlerce kullanım noktası
       tek tek değiştirilmeden, TÜM app genelinde tutarlı Liquid Glass hissi sağlanır. ---- */
${sel} [class~="bg-white"]:not(button):not(a) {
  background: ${glassBg} !important;
  backdrop-filter: blur(20px) saturate(1.5);
  -webkit-backdrop-filter: blur(20px) saturate(1.5);
  border-radius: 20px !important;
  ${isDark ? "color: var(--zen-text-dark) !important;" : ""}
}
${isDark ? `/* Karanlık cam bg-white içindeki hardcoded Tailwind koyu metin sınıfları → açık renk */
${sel} [class~="bg-white"] .text-slate-900,
${sel} [class~="bg-white"] .text-gray-900,
${sel} [class~="bg-white"] .text-slate-800,
${sel} [class~="bg-white"] .text-gray-800,
${sel} [class~="bg-white"] .text-slate-700,
${sel} [class~="bg-white"] .text-gray-700,
${sel} [class~="bg-white"].text-slate-900,
${sel} [class~="bg-white"].text-gray-900,
${sel} [class~="bg-white"].text-slate-800,
${sel} [class~="bg-white"].text-slate-700 {
  color: var(--zen-text-dark) !important;
}` : ""}
${sel} [class~="bg-slate-50"]:not(main):not(button):not(a), ${sel} [class~="bg-slate-100"]:not(main):not(button):not(a) {
  background: ${isDark ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.4)"} !important;
  backdrop-filter: blur(14px) saturate(1.3);
  border-radius: 16px !important;
  ${isDark ? "color: var(--zen-text-dark) !important;" : ""}
}
${sel} [class~="border-slate-200"], ${sel} [class~="border-slate-300"], ${sel} [class~="border-slate-100"] {
  border-color: ${glow} !important;
}

/* ---- Derinlik: yumuşak beyaz parlama + ince gölgeler ---- */
${sel} .zen-input {
  background: ${isDark ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.55)"} !important;
  backdrop-filter: blur(14px);
  border: 1px solid ${glow} !important;
  box-shadow: inset 0 1px 2px ${isDark ? "rgba(0,0,0,0.3)" : "rgba(0,0,0,0.04)"};
}
${sel} .zen-input:focus {
  box-shadow: inset 0 1px 2px ${isDark ? "rgba(0,0,0,0.3)" : "rgba(0,0,0,0.04)"}, 0 0 0 4px color-mix(in srgb, var(--zen-red) 22%, transparent);
}
${sel} .zen-chip {
  background: color-mix(in srgb, var(--zen-red) 12%, transparent);
  border-color: color-mix(in srgb, var(--zen-red) 30%, transparent) !important;
  backdrop-filter: blur(8px);
}
${sel} .zen-table thead th {
  backdrop-filter: blur(10px);
}
${sel} .zen-table tbody tr:hover {
  background: color-mix(in srgb, var(--zen-red) 6%, transparent) !important;
}

/* ---- Liquid butonlar: sıvı-metal gradyan + cam parlaması + hover sweep ---- */
${sel} .zen-btn-primary {
  position: relative;
  overflow: hidden;
  border: none !important;
  background: linear-gradient(160deg, color-mix(in srgb, white 32%, var(--zen-red)) 0%, var(--zen-red) 48%, color-mix(in srgb, black 15%, var(--zen-red)) 100%) !important;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.55), inset 0 -2px 3px rgba(0,0,0,0.15), 0 10px 22px -8px color-mix(in srgb, var(--zen-red) 65%, transparent);
  transition: filter 0.2s ease, transform 0.08s ease, box-shadow 0.25s ease;
}
${sel} .zen-btn-primary::after {
  content: ""; position: absolute; top: 0; left: -60%; width: 40%; height: 100%;
  background: linear-gradient(120deg, transparent, rgba(255,255,255,0.4), transparent);
  transform: skewX(-20deg); transition: left 0.55s ease; pointer-events: none;
}
${sel} .zen-btn-primary:hover { filter: brightness(1.08) saturate(1.08); }
${sel} .zen-btn-primary:hover::after { left: 120%; }
${sel} .zen-btn-primary:active { transform: scale(0.96); filter: brightness(0.95); }
${sel} .zen-btn-ghost, ${sel} .zen-btn-secondary {
  background: ${isDark ? "rgba(255,255,255,0.07)" : "rgba(255,255,255,0.55)"} !important;
  backdrop-filter: blur(16px) saturate(1.4);
  border: 1px solid ${glow} !important;
  box-shadow: inset 0 1px 0 ${glowSoft};
  transition: background 0.2s ease, transform 0.08s ease;
}
${sel} .zen-btn-ghost:hover, ${sel} .zen-btn-secondary:hover { background: ${isDark ? "rgba(255,255,255,0.13)" : "rgba(255,255,255,0.85)"} !important; }
${sel} .zen-btn-ghost:active, ${sel} .zen-btn-secondary:active { transform: scale(0.96); }

/* ---- Apple estetiği: sadeleştirilmiş tipografi ---- */
${sel} .font-black, ${sel} .font-extrabold { font-weight: 700 !important; letter-spacing: -0.015em !important; }
${sel} h1, ${sel} h2, ${sel} h3 { letter-spacing: -0.02em !important; }

/* ---- İnce, SF Symbols hissi veren ikonlar (lucide varsayılanından daha ince çizgi) ---- */
${sel} svg { stroke-width: 1.6 !important; }

/* ---- Hero banner: açık modda mor gradyan → mavi ---- */
${!isDark ? `
${sel} .zen-hero-liquid {
  background-image: linear-gradient(to bottom right, #1B50E0, #1644CC, #1138B5) !important;
  border-color: rgba(99,160,255,0.35) !important;
  box-shadow: 0 20px 40px -12px rgba(27,80,224,0.35) !important;
}
${sel} .zen-hero-liquid .bg-fuchsia-500\\/15 {
  background-color: rgba(99,180,255,0.12) !important;
}

/* Fiyatlandırma tablosu (CustomerPricingTab) */
${sel} .zen-pricing-panel {
  background: rgba(255,255,255,0.88) !important;
  color: #1e293b !important;
}
${sel} .zen-pricing-panel [class*="border-white"] { border-color: rgba(0,0,0,0.08) !important; }
${sel} .zen-pricing-panel [class*="text-slate-2"],
${sel} .zen-pricing-panel [class*="text-slate-3"] { color: #334155 !important; }
${sel} .zen-pricing-panel [class*="bg-white\\/"] { background-color: rgba(248,250,252,0.70) !important; }
${sel} .zen-pricing-panel .text-white { color: #1e293b !important; }

/* Cari Bilgileri bölüm arka planları (bg-white/2 = %2 beyaz = neredeyse şeffaf) */
${sel} [data-testid="customer-fullpage"] .bg-white\\/2 {
  background-color: rgba(255,255,255,0.75) !important;
}
${sel} [data-testid="customer-fullpage"] .border-white\\/5 {
  border-color: rgba(0,0,0,0.08) !important;
}

/* ================================================================
   MÜŞTERİ DETAY SAYFASI — açık modda koyu hex arkaplanları sıfırla
   Liste sayfasıyla aynı: açık mavi arka plan + koyu yazılar
   ================================================================ */

/* Tam sayfa sarmalayıcı → liste sayfası gibi açık mavi */
${sel} [data-testid="customer-fullpage"] {
  background: linear-gradient(160deg, #EEF5FF 0%, #E6F0FF 100%) !important;
  color: #1e293b !important;
}

/* Tüm #0xxxxx ve #06xxxx koyu hex arkaplanlar → beyaz panel */
${sel} [data-testid="customer-fullpage"] [class*="bg-[#0"] {
  background-color: rgba(255,255,255,0.90) !important;
  color: #1e293b !important;
}

/* Koyu lacivert buton/rozet renkleri (#1a2a…, #213…) → açık mavi */
${sel} [data-testid="customer-fullpage"] [class*="bg-[#1a2a"],
${sel} [data-testid="customer-fullpage"] [class*="bg-[#213"] {
  background-color: rgba(219,234,254,0.85) !important;
  color: #1d4ed8 !important;
}

/* Sticky header → yarı saydam açık */
${sel} [data-testid="customer-fullpage"] .sticky {
  background-color: rgba(238,245,255,0.96) !important;
  backdrop-filter: blur(20px) !important;
}

/* Tablo/satır detay açılımları → çok açık gri */
${sel} [data-testid="customer-fullpage"] [class*="border-white\\/"] {
  border-color: rgba(0,0,0,0.09) !important;
}

/* Beyaz renk yazılar → koyu */
/* Açık gri metin → koyu (özellikle sipariş kalem satırları) */
${sel} [data-testid="customer-fullpage"] .text-slate-100 { color: #1e293b !important; }
${sel} [data-testid="customer-fullpage"] .text-slate-200 { color: #334155 !important; }
${sel} [data-testid="customer-fullpage"] .text-slate-300 { color: #475569 !important; }
${sel} [data-testid="customer-fullpage"] .text-white { color: #1e293b !important; }
${sel} [data-testid="customer-fullpage"] .text-slate-400 { color: #475569 !important; }
${sel} [data-testid="customer-fullpage"] .text-gray-400 { color: #475569 !important; }
/* Sipariş kalem satır arka planları (bg-white/3, bg-white/5 = neredeyse şeffaf) → görünür */
${sel} [data-testid="customer-fullpage"] .bg-white\\/3,
${sel} [data-testid="customer-fullpage"] .bg-white\\/5 {
  background-color: rgba(241,245,249,0.85) !important;
  border-color: rgba(0,0,0,0.09) !important;
}

/* sky-300 (mavi rozet metinleri) → derin mavi */
${sel} [data-testid="customer-fullpage"] .text-sky-300 { color: #0369a1 !important; }

/* Modal overlay → liste sayfasıyla uyumlu yarı saydam gri */
${sel} .fixed[class*="bg-black"] {
  background-color: rgba(71,85,105,0.40) !important;
  backdrop-filter: blur(4px) !important;
}

/* Cari düzenleme modal içi → temiz beyaz panel */
${sel} [data-testid="customer-fullpage"] .zen-panel,
${sel} .zen-panel[data-testid="ekstre-share-modal"],
${sel} .zen-panel[data-testid="bulk-import-modal"] {
  background: rgba(255,255,255,0.92) !important;
  color: #1e293b !important;
  border-color: rgba(0,0,0,0.09) !important;
}
` : ""}
`;
}

/**
 * Verilen tema tanımı için CSS metni üretir: değişken override'ları + hardcoded hex sınıf
 * yeniden boyama + buton/panel stil varyantı. `[data-theme="ID"]` scope'unda çalışır.
 */
export function generateThemeCSS(theme) {
  if (!theme || theme.id === "orijinal") return "";
  const c = theme.colors || {};
  const sel = `[data-theme="${theme.id}"]`;
  const vars = [];
  if (c.primary) { vars.push(`--zen-red: ${c.primary};`); vars.push(`--zen-red-hover: ${c.primaryHover || c.primary};`); }
  if (c.accent) vars.push(`--zen-accent: ${c.accent};`);
  if (c.bgLight) vars.push(`--zen-bg-light: ${c.bgLight};`);
  if (c.panelLight) vars.push(`--zen-panel-light: ${c.panelLight};`);
  if (c.borderLight) vars.push(`--zen-border-light: ${c.borderLight};`);
  if (c.textLight) vars.push(`--zen-text-light: ${c.textLight};`);
  if (c.mutedLight) vars.push(`--zen-muted-light: ${c.mutedLight};`);
  if (c.rowAltLight) vars.push(`--zen-row-alt-light: ${c.rowAltLight};`);
  if (c.bgDark) vars.push(`--zen-bg-dark: ${c.bgDark};`);
  if (c.panelDark) vars.push(`--zen-panel-dark: ${c.panelDark};`);
  if (c.panel2Dark) vars.push(`--zen-panel-2-dark: ${c.panel2Dark};`);
  if (c.borderDark) vars.push(`--zen-border-dark: ${c.borderDark};`);
  if (c.textDark) vars.push(`--zen-text-dark: ${c.textDark};`);
  if (c.mutedDark) vars.push(`--zen-muted-dark: ${c.mutedDark};`);
  if (c.rowAltDark) vars.push(`--zen-row-alt-dark: ${c.rowAltDark};`);
  if (theme.radius) vars.push(`--zen-radius: ${theme.radius};`);
  if (theme.font) vars.push(`--zen-font: ${theme.font};`);

  let css = `${sel} { ${vars.join(" ")} }\n`;
  css += `${sel}, ${sel} body, ${sel} #root { font-family: var(--zen-font); }\n`;
  css += `${sel} .zen-panel { border-radius: var(--zen-radius); }\n`;
  css += `${sel} .zen-input { border-radius: calc(var(--zen-radius) * 0.62); }\n`;
  css += `${sel} .zen-btn-primary, ${sel} .zen-btn-ghost, ${sel} .zen-btn-secondary { border-radius: calc(var(--zen-radius) * 0.62); }\n`;
  if (theme.glass) {
    css += `${sel} .zen-panel { backdrop-filter: blur(16px) saturate(1.3); }\n`;
  }
  if (theme.buttonStyle && BUTTON_STYLE_CSS[theme.buttonStyle]) {
    css += `${sel} { } ${BUTTON_STYLE_CSS[theme.buttonStyle].split("\n").map(l => l.trim() ? `${sel} ${l.trim()}` : "").join("\n")}\n`;
  }

  // Hardcoded hex Tailwind sınıflarını (dark:/hover: önekli olsalar da) role göre yeniden boyar.
  // ":not([class*=\"X/\"])" eklenir ki "hover:bg-[#E5322A]/5" gibi opaklık-modifikatörlü varyantlar
  // (kasıtlı olarak yarı-şeffaf/hover aksanı) yanlışlıkla solid renkle ezilmesin.
  for (const [hex, role] of Object.entries(HEX_ROLE_MAP)) {
    const roleColor = { primary: c.primary, borderDark: c.borderDark, panelDark: c.panelDark, panel2Dark: c.panel2Dark, bgDark: c.bgDark }[role];
    if (!roleColor) continue;
    for (const p of HEX_PROPS) {
      const base = `${p.prefix}-[#${hex}]`;
      const guard = `:not([class*="${base}/"])`;
      if (p.prefix === "ring") {
        css += `${sel} [class*="${base}"]${guard} { box-shadow: 0 0 0 3px color-mix(in srgb, ${roleColor} 45%, transparent) !important; }\n`;
      } else {
        css += `${sel} [class*="${base}"]${guard} { ${p.css}: ${roleColor} !important; }\n`;
      }
    }
  }
  // Apple (Liquid Glass) temaları için tam bileşen stili — renk değişkenlerinin üzerine eklenir
  if (theme.category === "apple") css += buildAppleGlassCSS(theme, sel);
  return css;
}

// ============ ÖZEL TEMA OLUŞTURUCU — yardımcılar ============

export const FONT_OPTIONS = [
  { id: "manrope", label: "Manrope (Varsayılan)", stack: "'Manrope', Inter, ui-sans-serif, system-ui, sans-serif" },
  { id: "inter", label: "Inter", stack: "'Inter', ui-sans-serif, system-ui, sans-serif" },
  { id: "system", label: "Sistem Yazı Tipi", stack: "-apple-system, BlinkMacSystemFont, system-ui, sans-serif" },
  { id: "jetbrains", label: "JetBrains Mono", stack: "'JetBrains Mono', ui-monospace, monospace" },
  { id: "nunito", label: "Nunito", stack: "'Nunito', ui-sans-serif, sans-serif" },
  { id: "chivo", label: "Chivo", stack: "'Chivo', ui-sans-serif, sans-serif" },
  { id: "outfit", label: "Outfit", stack: "'Outfit', ui-sans-serif, sans-serif" },
];

export const BUTTON_STYLE_OPTIONS = [
  { id: "solid", label: "Solid" },
  { id: "outline", label: "Outline" },
  { id: "glass", label: "Glass" },
  { id: "clay", label: "Neumorphic" },
];

const CUSTOM_THEMES_KEY = "zen_custom_themes";
const ACTIVE_THEME_KEY = "zen_color_theme";
const ANIMATIONS_KEY = "zen_theme_animations";
const CURSOR_KEY = "zen_cursor";

export function getCustomThemes() {
  try {
    const raw = localStorage.getItem(CUSTOM_THEMES_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) { return []; }
}

export function persistCustomThemes(list) {
  localStorage.setItem(CUSTOM_THEMES_KEY, JSON.stringify(list));
}

export function getStoredActiveThemeId() {
  return localStorage.getItem(ACTIVE_THEME_KEY) || "orijinal";
}

export function setStoredActiveThemeId(id) {
  localStorage.setItem(ACTIVE_THEME_KEY, id);
}

export function getStoredAnimationsEnabled() {
  const v = localStorage.getItem(ANIMATIONS_KEY);
  return v === null ? true : v === "1";
}

export function setStoredAnimationsEnabled(val) {
  localStorage.setItem(ANIMATIONS_KEY, val ? "1" : "0");
}

export const CURSOR_OPTIONS = [
  { id: "default", label: "Sistem Varsayılanı" },
  { id: "arrow", label: "Klasik Ok (Net)" },
  { id: "zenarrow", label: "ZEN Kırmızı Ok" },
  { id: "pen", label: "Kalem" },
  { id: "cross", label: "Hassas Artı" },
];
export function getStoredCursorId() {
  const v = localStorage.getItem(CURSOR_KEY) || "default";
  return CURSOR_OPTIONS.some((c) => c.id === v) ? v : "default";
}
export function setStoredCursorId(id) {
  localStorage.setItem(CURSOR_KEY, id);
}

// ---- Ana sayfa saati: dijital veya Apple analog kadran ----
const CLOCK_KEY = "zen_clock_style";
export const CLOCK_OPTIONS = [
  { id: "digital", label: "Dijital" },
  { id: "analog", label: "Analog (Apple)" },
];
export function getStoredClockStyle() {
  return localStorage.getItem(CLOCK_KEY) || "digital";
}
export function setStoredClockStyle(id) {
  localStorage.setItem(CLOCK_KEY, id);
}

/** Özel tema oluşturucudaki form değerlerinden BUILTIN_THEMES ile uyumlu bir tema nesnesi üretir. */
export function buildCustomTheme({ id, name, mode, primary, accent, fontId, radiusPx, buttonStyle }) {
  const font = FONT_OPTIONS.find(f => f.id === fontId) || FONT_OPTIONS[0];
  return {
    id: id || `custom_${Date.now()}`,
    name: name?.trim() || "Özel Tema",
    category: "custom",
    mode,
    desc: "Kullanıcı tanımlı özel tema.",
    colors: { primary, primaryHover: primary, accent },
    radius: `${radiusPx}px`,
    font: font.stack,
    fontId: font.id,
    buttonStyle,
    glass: buttonStyle === "glass",
    animation: "none",
  };
}
